import { useContext } from "react";
import { cvFromChatToSubscriptionPocContext } from "../context/CvFromChatToSubscriptionPocContext";

export const useCvFromChatToSubscriptionPoc = () =>
  useContext(cvFromChatToSubscriptionPocContext);
